import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Row, Col, Button, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { FaChevronLeft, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import './Summary.css';
import Reporting from './Reporting';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import CertificationStatus from './CertificationStatus';
import ActionSummary from './ActionSummary';
import ActionDue from './ActionDue';
import StaticMapView from '../Map/StaticMapView';
import MyFarm from './MyFarm';
import WaterwayFencingSummary from './WaterwayFencingSummary';
import RiparianPlantingSummary from './RiparianPlantingSummary';
import PagebyPagebreakdown from './PagebyPagebreakdown';
import ForestryandBushArea from './ForestryandBushArea';
import RiskManagement from './RiskManagement';
import { toPng } from 'html-to-image';
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { flushSync } from "react-dom";
import polyline from '@mapbox/polyline';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

Chart.register(ChartDataLabels);


const Summary = ({ handleWizardChanged, handleWizardChangedBack, refreshToken }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(true); const [actionDueImage, setActionDueImage] = useState(null);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    }; const [showEnvironmentCanterbury, setShowEnvironmentCanterbury] = useState(false);
    const [farmName, setFarmName] = useState(localStorage.getItem("defaultFarmName")); const [farmUniqueId, setFarmUniqueId] = useState(localStorage.getItem("defaultFarmUniqueId"));
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const refActionDueChart = useRef(null);
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId")); const [showReportData, setShowReportData] = useState(false)
    const [quickDetail, setQuickDetail] = useState({ farmName: '', responsiblePerson: '', totalArea: null, leaseArea: null, irrigatedArea: null })
    const [loading, setLoading] = useState(true); const [generateReport, setGenerateReport] = useState(false); const [generateFEPReport, setGenerateFEPReport] = useState(false);
    const [staticMapLoading, setStaticMapLoading] = useState(true);
    const [summary, setSummary] = useState({
        ghgItemTypesList:[],
        outlineList: [], itemList: [], actionList: [], actionTypeList: [], actionDues: '', ongoingActionDues:'', farmCompleteGMPList: [], GMPList: [],
        Section: 'Summary', SectionName: 'Summary', isWizardCompleted: false, wizardDetails: [], zoomLevel: 15, catchmentContextZoomlevel: 15, reportDocumentList: [], certificationAndAuditStatus: {}
    });
    const [landsoil, setLandSoil] = useState({ outlineList: [], itemList: [] });
    const [waterway, setWaterway] = useState({ outlineList: [], itemList: [] });
    const [mahingaKai, setMahingaKai] = useState({ outlineList: [], itemList: [] });
    const [lmu, setLmu] = useState({ outlineList: [], itemList: [] }); const [allItems, setAllItems] = useState({ outlineList: [], itemList: [] }); const [itemActionPlanList, setItemActionPlanList] = useState({ outlineList: [], itemList: [] });
    const [itemActionPlanList1, setItemActionPlanList1] = useState({ outlineList: [], itemList: [] });
    const [itemPhysicalWorksPlanList, setItemPhysicalWorksPlanList] = useState({ outlineList: [], itemList: [] }); const [propertyMapItems, setPropertyMapItems] = useState({ outlineList: [], itemList: [] });
    const [wholeMapItems, setWholeMapItems] = useState({ outlineList: [], itemList: [] });
    const [infrastructure, setInfrastructure] = useState({ outlineList: [], itemList: [] });
    const [freshWaterIrrigation, setFreshWaterIrrigation] = useState({ outlineList: [], itemList: [] });
    const [effluentDisposal, setEffluentDisposal] = useState({ outlineList: [], itemList: [] });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 });
    const [catchmentContext, setCatchmentContext] = useState({ outlineList: [], itemList: [] });
    const [outline, setOutline] = useState({ outlineList: [], itemList: [] });
    const [riskmap, setRiskmap] = useState({ outlineList: [], itemList: [] });
    const [cropping, setCropping] = useState({ outlineList: [], itemList: [] }); const [nutrients, setNutrients] = useState({ outlineList: [], itemList: [] });
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false,
        isFarmOutlineEditable: false, zoomLevel: 5, polytype: '', itemsEditable: false, showLabel: false
    }); const [autoUploadSaving, setAutoUploadSaving] = useState(false);
    const [catchmentContextMapDetails, setCatchmentContextMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false,
        isFarmOutlineEditable: false, zoomLevel: 5, polytype: '', itemsEditable: false
    });
    const [actionSummary, setActionSummary] = useState([]);
    const [riskModel, setRiskModel] = useState({});
    const [reportButtonVisible, setReportButtonVisible] = useState(false); const [propertyMapUrl, setPropertyMapUrl] = useState('');
    const [fepOnly, setFEPOnly] = useState(false);

    const handleSetFEPOnly = (e) => {
        setFEPOnly(e.target.checked);
    }

    useEffect(() => {
        setStaticMapLoading(true);
        setLoading(true);
        OnPageload();
    }, []);
    const [biodiversity, setBiodiversity] = useState({ outlineList: [], itemList: [], SectionName: 'Biodiversity', Section: 'Biodiversity', isWizardCompleted: false, sectionObj: {} });
    const [sectionList, setSectionList] = useState([]); const [tempItemList, setTempItemList] = useState([]);

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/summary/GetSummaryDetails/', {
                params: {
                    farmId: farmId
                }
            }
            );
            setOutline({ ...outline, itemList: [], outlineList: response.data.outlineList });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel });
            setCatchmentContextMapDetails({ ...mapDetails, zoomLevel: response.data.selectedCatchmentContextZoomlevel });
            setLandSoil({ ...landsoil, itemList: response.data.landsoilList, outlineList: response.data.outlineList });
            setWaterway({ ...waterway, itemList: response.data.waterwaysList, outlineList: response.data.outlineList });
            setMahingaKai({ ...mahingaKai, itemList: response.data.mahingaKaiList, outlineList: response.data.outlineList });
            setLmu({ ...lmu, itemList: response.data.lmuItemList, outlineList: response.data.outlineList });
            setInfrastructure({ ...infrastructure, itemList: response.data.infrastructureList, outlineList: response.data.outlineList });
            setPropertyMapItems({ ...propertyMapItems, itemList: response.data.propertyMapitemList, outlineList: response.data.outlineList });
            setWholeMapItems({ ...wholeMapItems, itemList: response.data.wholeMapitemList, outlineList: response.data.outlineList });
            setAllItems({ ...allItems, itemList: response.data.allItemsList, outlineList: response.data.outlineList });
            setItemActionPlanList({ ...itemActionPlanList, itemList: response.data.itemActionPlanList, outlineList: response.data.outlineList });
            setItemActionPlanList1({ ...itemActionPlanList1, itemList: response.data.itemActionPlanList1, outlineList: response.data.outlineList });
            setItemPhysicalWorksPlanList({ ...itemPhysicalWorksPlanList, itemList: response.data.itemPhysicalWorksPlanList, outlineList: response.data.outlineList });
            setFreshWaterIrrigation({ ...freshWaterIrrigation, itemList: response.data.freshwaterIrrigationList, outlineList: response.data.outlineList });
            setCatchmentContext({ ...catchmentContext, itemList: response.data.catchmentContextList, outlineList: response.data.outlineList });
            setEffluentDisposal({ ...effluentDisposal, itemList: response.data.effluentDisposalList, outlineList: response.data.outlineList });
            setCropping({ ...cropping, itemList: response.data.cropAreaItems, outlineList: response.data.outlineList });
            setNutrients({ ...nutrients, itemList: response.data.nutrientItems, outlineList: response.data.outlineList });
            setStaticMapLoading(false);
            setShowEnvironmentCanterbury(response.data.showEnvironmentCanterbury);
            var riskItems = [];
            response.data.landsoilList.filter(x => (x.riskLabel == "R")).forEach(item => riskItems.push(item));
            response.data.waterwaysList.filter(x => (x.riskLabel == "R")).forEach(item => riskItems.push(item));
            response.data.mahingaKaiList.filter(x => (x.riskLabel == "R")).forEach(item => riskItems.push(item));
            response.data.lmuItemList.filter(x => (x.riskLabel == "R")).forEach(item => riskItems.push(item));
            response.data.infrastructureList.filter(x => (x.riskLabel == "R")).forEach(item => riskItems.push(item));
            response.data.freshwaterIrrigationList.filter(x => (x.riskLabel == "R")).forEach(item => riskItems.push(item));
            response.data.effluentDisposalList.filter(x => (x.riskLabel == "R")).forEach(item => riskItems.push(item));
            setBiodiversity({
                ...biodiversity, outlineList: response.data.outlineList, itemList: [], isWizardCompleted: response.data.isFWFPCompleted, sectionObj: response.data.section
            }); setTempItemList(response.data.riskItemList);
            setSectionList(response.data.myFarmSections); setItemList(response.data.riskItemList);
            setSummary({
                ...summary, ghgItemTypesList: response.data.ghgItemTypesList, outlineList: response.data.outlineList, itemList: response.data.itemList, actionList: response.data.allActionList,
                actionTypeList: response.data.actionTypeList, isWizardCompleted: response.data.isFWFPCompleted, actionDues: response.data.actionDues, ongoingActionDues: response.data.ongoingActionDues,
                wizardDetails: response.data.wizardDetails, zoomLevel: response.data.selectedZoomlevel, catchmentContextZoomlevel: response.data.selectedCatchmentContextZoomlevel,
                reportDocumentList: response.data.reportDocumentList, certificationAndAuditStatus: response.data.certificationAndAuditStatus
            });
            setRiskmap({ ...riskmap, itemList: riskItems, outlineList: response.data.outlineList })
            setQuickDetail(response.data.quickDetail);
            setActionSummary(response.data.actionSummary);
            setRiskModel(response.data.riskModel);
            await setPropertyMapStaticMapUrl(response.data.outlineList, response.data.propertyMapitemList, response.data.selectedZoomlevel);
            setPhysicalWorksMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.itemPhysicalWorksPlanList, response.data.selectedZoomlevel, false, false, 'PhysicalWorksMapImage'));
            setFarmDetailImageURL(await getStaticMapURL(response.data.outlineList, [], response.data.selectedZoomlevel, false, true, 'FarmDetailImage'));
            setAllActionsMapImage1URL(await getStaticMapURL(response.data.outlineList, response.data.itemActionPlanList1, response.data.selectedZoomlevel, false, false, 'AllActionsMapImage1'));
            setAllItemsMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.allItemsList, response.data.selectedZoomlevel, false, false, 'AllItemsMapImage'));
            setAllActionsMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.itemActionPlanList, response.data.selectedZoomlevel, false, false, 'AllActionsMapImage'));
            setEffluentDisposalMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.effluentDisposalList, response.data.selectedZoomlevel, false, false, 'EffluentDisposalMapImage'));
            setCroppingMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.cropAreaItems, response.data.selectedZoomlevel, false, false, 'CroppingMapImage'));
            setInfrastructureMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.infrastructureList, response.data.selectedZoomlevel, false, false, 'InfrastructureMapImage'));
            setWholeMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.wholeMapitemList, response.data.selectedZoomlevel, false, false, 'WholeMapImage'));
            setLandUnitsMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.lmuItemList, response.data.selectedZoomlevel, true, false, 'LandUnitsMapImage'));
            setWaterwayMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.waterwaysList, response.data.selectedZoomlevel, false, false, 'WaterwayMapImage'));
            setNutrientMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.nutrientItems, response.data.selectedZoomlevel, false, false, 'NutrientMapImage'));
            setLandAndErosionMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.landsoilList, response.data.selectedZoomlevel, false, false, 'LandAndErosionMapImage'));
            setFreshwaterIrrigationMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.freshwaterIrrigationList, response.data.selectedZoomlevel, false, false, 'FreshwaterIrrigationMapImage'));
            setMahingKaiMapImageURL(await getStaticMapURL(response.data.outlineList, response.data.mahingaKaiList, response.data.selectedZoomlevel, false, false, 'MahingKaiMapImage'));
            setWaterTestSitesImage2URL(await getStaticMapURL(response.data.outlineList, response.data.catchmentContextList, response.data.selectedCatchmentContextZoomlevel, false, false, 'WaterTestSitesImage2'));
            setReportButtonVisible(true);
            setLoading(false);
            //setTimeout(() => {
                
            //}, 5000);

        } catch (err) {
            console.log(err);
        }
    }
    const [showRiskItems, setShowRiskItems] = useState(false); const [itemList, setItemList] = useState([]);
    const showHideRiskItems = async (e) => {
        setShowRiskItems(e.checked);
        hideItems();
    }

    const showHideRiskMapItem = async (e, item1) => {
        let tempList = sectionList;
        tempList.map((sectionList) => {
            if (sectionList.name === item1.name) {
                sectionList.checked = e.target.checked;
            }
            return sectionList;
        });

        flushSync(() => {
            setSectionList(prevSectionList => {
                const newSectionList = [...prevSectionList];
                return newSectionList;
            });
        });
        const response = hideItems();
        toast.promise(response, {
            loading: 'Refreshing Map...',
            success: 'Map refreshed!',
            error: 'Error when refreshing map',
        });
        
    }

    const hideItems = async (e) => {
        let tempList = sectionList;
        let tempItems = [];
        tempList.forEach((value, key) => {
            if (value.checked) {
                tempItemList.filter(x => x.sectionName == value.displayName).forEach((value1, key1) => {
                    tempItems.push(value1);
                });
            }
        });
        let form = {
            Items: tempItems
        }
        let response = await apiPost(
            '/api/summary/RefreshMyFarm/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data.status) {
            if (document.getElementById('showRiskItems').checked) {
                let tempFilteredItems1 = [];
                tempItems.filter(x => x.itemActions.riskResult == "R").forEach((value1, key1) => {
                    tempFilteredItems1.push(value1);
                });
                setItemList(tempFilteredItems1);
                setBiodiversity({ ...biodiversity, itemList: tempFilteredItems1 });
            }
            else {
                setItemList(tempItems);
                setBiodiversity({ ...biodiversity, itemList: tempItems });
                setPropertyMapItems({ ...propertyMapItems, itemList: response.data.content })
                await setPropertyMapStaticMapUrl(propertyMapItems.outlineList, response.data.content, mapDetails.zoomLevel);
            }
        }
    }
    const [PhysicalWorksMapImageURL, setPhysicalWorksMapImageURL] = useState('');
    const [FarmDetailImageURL, setFarmDetailImageURL] = useState(''); const [AllActionsMapImage1URL, setAllActionsMapImage1URL] = useState('');
    const [AllItemsMapImageURL, setAllItemsMapImageURL] = useState(''); const [AllActionsMapImageURL, setAllActionsMapImageURL] = useState('');
    const [EffluentDisposalMapImageURL, setEffluentDisposalMapImageURL] = useState(''); const [CroppingMapImageURL, setCroppingMapImageURL] = useState('');
    const [InfrastructureMapImageURL, setInfrastructureMapImageURL] = useState(''); const [LandUnitsMapImageURL, setLandUnitsMapImageURL] = useState('');
    const [WholeMapImageURL, setWholeMapImageURL] = useState('');
    const [WaterwayMapImageURL, setWaterwayMapImageURL] = useState(''); const [NutrientMapImageURL, setNutrientMapImageURL] = useState('');
    const [LandAndErosionMapImageURL, setLandAndErosionMapImageURL] = useState(''); const [FreshwaterIrrigationMapImageURL, setFreshwaterIrrigationMapImageURL] = useState('');
    const [MahingKaiMapImageURL, setMahingKaiMapImageURL] = useState(''); const [WaterTestSitesImage2URL, setWaterTestSitesImage2URL] = useState('');
    const getStaticMapURL = async (outlineList1, itemList1, zoomLevel1, isLU, farmCentreReq,id) => {
        try {
            const mapType = "sat";
            const size = "1750,1750";
            const outlineList = outlineList1;
            const itemList = itemList1;
            const zoomLevel = zoomLevel1;
            var farmCenter = '';
            var url = '';
            var center = await getFarmCentre(outlineList1, zoomLevel1);
            farmCenter = farmCentreReq && renderFarmCenter(outlineList);
            var farmOutline = renderOutline(outlineList);
            if (id == "AllItemsMapImage" || id == "AllActionsMapImage" || id == "EffluentDisposalMapImage" || id == "CroppingMapImage"
                || id == "InfrastructureMapImage" || id == "LandUnitsMapImage" || id == "WaterwayMapImage" || id == "NutrientMapImage"
                || id == "LandAndErosionMapImage" || id == "FreshwaterIrrigationMapImage" || id == "MahingKaiMapImage" || id == "WaterTestSitesImage2") {
                var itemMarkerString = renderItemDefaultMarker(itemList);
                var result = await renderPropertyMapItemDefaultMarker(itemList, isLU);
                var itemPolygonMarkerString = '';
                if (result.itemPolygonMarkerString != undefined) {
                    itemPolygonMarkerString = result.itemPolygonMarkerString;
                }
                var itemPolylineMarkerString = '';
                if (result.itemPolylineMarkerString != undefined) {
                    itemPolylineMarkerString = result.itemPolylineMarkerString;
                }
                var itemRectangleMarkerString = '';
                if (result.itemRectangleMarkerString != undefined) {
                    itemRectangleMarkerString = result.itemRectangleMarkerString;
                }
                var itemCircleMarkerString = '';
                if (result.itemCircleMarkerString != undefined) {
                    itemCircleMarkerString = result.itemCircleMarkerString;
                }
                var itemPolygonString = '';
                if (result.itemPolygonString != undefined) {
                    itemPolygonString = result.itemPolygonString;
                }
                var itemPolylineString = '';
                if (result.itemPolylineString != undefined) {
                    itemPolylineString = result.itemPolylineString;
                }
                var itemRectangleString = '';
                if (result.itemRectangleString != undefined) {
                    itemRectangleString = result.itemRectangleString;
                }
                var itemCircleString = '';
                if (result.itemCircleString != undefined) {
                    itemCircleString = result.itemCircleString;
                }
                let locations = "";
                if (farmCenter != "")
                    locations = farmCenter;
                if (itemMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemMarkerString : itemMarkerString
                if (itemPolygonMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemPolygonMarkerString : itemPolygonMarkerString
                if (itemPolylineMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemPolylineMarkerString : itemPolylineMarkerString
                if (itemRectangleMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemRectangleMarkerString : itemRectangleMarkerString
                if (itemCircleMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemCircleMarkerString : itemCircleMarkerString
                var defaultMarker = 'marker-num-1A959E';
                if (id == 'AllItemsMapImage') {
                    defaultMarker = 'marker-1A959E';
                }
                url = `https://www.mapquestapi.com/staticmap/v5/map?key=HBdKcEDw06L2TRAg1rKBXEhkPjfkSRb4&size=${size}&center=${center.lat},${center.lng}&zoom=${zoomLevel}&type=${mapType}&locations=${locations}&defaultMarker=${defaultMarker}&shape=${farmOutline}&shape=${itemPolygonString}&shape=${itemPolylineString}&shape=${itemRectangleString}&shape=${itemCircleString}`;
            }
            else {
                var itemMarkerString = renderItemMarker(itemList);
                var result = await renderPropertyMapItem(itemList, isLU);
                var itemPolygonMarkerString = '';
                if (result.itemPolygonMarkerString != undefined) {
                    itemPolygonMarkerString = result.itemPolygonMarkerString;
                }
                var itemPolylineMarkerString = '';
                if (result.itemPolylineMarkerString != undefined) {
                    itemPolylineMarkerString = result.itemPolylineMarkerString;
                }
                var itemRectangleMarkerString = '';
                if (result.itemRectangleMarkerString != undefined) {
                    itemRectangleMarkerString = result.itemRectangleMarkerString;
                }
                var itemCircleMarkerString = '';
                if (result.itemCircleMarkerString != undefined) {
                    itemCircleMarkerString = result.itemCircleMarkerString;
                }
                var itemPolygonString = '';
                if (result.itemPolygonString != undefined) {
                    itemPolygonString = result.itemPolygonString;
                }
                var itemPolylineString = '';
                if (result.itemPolylineString != undefined) {
                    itemPolylineString = result.itemPolylineString;
                }
                var itemRectangleString = '';
                if (result.itemRectangleString != undefined) {
                    itemRectangleString = result.itemRectangleString;
                }
                var itemCircleString = '';
                if (result.itemCircleString != undefined) {
                    itemCircleString = result.itemCircleString;
                }
                let locations = "";
                if (farmCenter != "")
                    locations = farmCenter;
                if (itemMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemMarkerString : itemMarkerString
                if (itemPolygonMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemPolygonMarkerString : itemPolygonMarkerString
                if (itemPolylineMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemPolylineMarkerString : itemPolylineMarkerString
                if (itemRectangleMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemRectangleMarkerString : itemRectangleMarkerString
                if (itemCircleMarkerString != "")
                    locations = locations != "" ? locations + "||" + itemCircleMarkerString : itemCircleMarkerString;
                url = `https://www.mapquestapi.com/staticmap/v5/map?key=HBdKcEDw06L2TRAg1rKBXEhkPjfkSRb4&size=${size}&center=${center.lat},${center.lng}&zoom=${zoomLevel}&type=${mapType}&locations=${locations}&shape=${farmOutline}&shape=${itemPolygonString}&shape=${itemPolylineString}&shape=${itemRectangleString}&shape=${itemCircleString}`;
            }
            return url;
        }
        catch {
            return '';
        }
    }

    const setPropertyMapStaticMapUrl = async (outlineList1, itemList1, zoomLevel1) => {
        try {
            const mapType = "sat";
            const size = "1750,1750";
            const outlineList = outlineList1;
            const itemList = itemList1;
            const zoomLevel = zoomLevel1;
            let isLU = false;
            var farmOutline = renderOutline(outlineList);
            var itemMarkerString = itemList.length > 0 && renderItemDefaultMarker(itemList);
            var center = await getFarmCentre(outlineList1, zoomLevel1);
            var result = await renderPropertyMapItemDefaultMarker(itemList, isLU);
            var itemPolygonMarkerString = '';
            if (result.itemPolygonMarkerString != undefined) {
                itemPolygonMarkerString = result.itemPolygonMarkerString;
            }
            var itemPolylineMarkerString = '';
            if (result.itemPolylineMarkerString != undefined) {
                itemPolylineMarkerString = result.itemPolylineMarkerString;
            }
            var itemRectangleMarkerString = '';
            if (result.itemRectangleMarkerString != undefined) {
                itemRectangleMarkerString = result.itemRectangleMarkerString;
            }
            var itemCircleMarkerString = '';
            if (result.itemCircleMarkerString != undefined) {
                itemCircleMarkerString = result.itemCircleMarkerString;
            }
            var itemPolygonString = '';
            if (result.itemPolygonString != undefined) {
                itemPolygonString = result.itemPolygonString;
            }
            var itemPolylineString = '';
            if (result.itemPolylineString != undefined) {
                itemPolylineString = result.itemPolylineString;
            }
            var itemRectangleString = '';
            if (result.itemRectangleString != undefined) {
                itemRectangleString = result.itemRectangleString;
            }
            var itemCircleString = '';
            if (result.itemCircleString != undefined) {
                itemCircleString = result.itemCircleString;
            }
            let locations = "";
            if (itemMarkerString != "")
                locations = locations != "" ? locations + "||" + itemMarkerString : itemMarkerString
            if (itemPolygonMarkerString != "")
                locations = locations != "" ? locations + "||" + itemPolygonMarkerString : itemPolygonMarkerString
            if (itemPolylineMarkerString != "")
                locations = locations != "" ? locations + "||" + itemPolylineMarkerString : itemPolylineMarkerString
            if (itemRectangleMarkerString != "")
                locations = locations != "" ? locations + "||" + itemRectangleMarkerString : itemRectangleMarkerString
            if (itemCircleMarkerString != "")
                locations = locations != "" ? locations + "||" + itemCircleMarkerString : itemCircleMarkerString

            var defaultMarker = 'marker-num-1A959E';
            //const response1 = await apiGet(
            //    `https://www.mapquestapi.com/staticmap/v5/map?key=HBdKcEDw06L2TRAg1rKBXEhkPjfkSRb4&size=${size}&center=${center.lat},${center.lng}&zoom=${zoomLevel}&type=${mapType}&locations=${locations}&defaultMarker=${defaultMarker}&shape=${farmOutline}&shape=${itemPolygonString}&shape=${itemPolylineString}&shape=${itemRectangleString}&shape=${itemCircleString}`);
            setPropertyMapUrl(`https://www.mapquestapi.com/staticmap/v5/map?key=HBdKcEDw06L2TRAg1rKBXEhkPjfkSRb4&size=${size}&center=${center.lat},${center.lng}&zoom=${zoomLevel}&type=${mapType}&locations=${locations}&defaultMarker=${defaultMarker}&shape=${farmOutline}&shape=${itemPolygonString}&shape=${itemPolylineString}&shape=${itemRectangleString}&shape=${itemCircleString}`);
        } catch (error) {
            console.error('Error fetching map image:', error);
        }
    }
    const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
            }
        });
    }
    const exportAutoUploadToPdf = async () => {
        setAutoUploadSaving(true);
        var ActionDue = null;
        toPng(elementRef.current, { cacheBust: true })
            .then((dataUrl) => {
                ActionDue = dataUrl;
                const response = handleAutoUploadPopupSave(ActionDue);
            })
            .catch((err) => {
                const response = handleAutoUploadPopupSave(null);
            });


    }

    const handleAutoUploadPopupSave = async (ActionDue) => {
        let form = {
            FarmDetailImage: FarmDetailImageURL,
            InfrastructureMapImage: InfrastructureMapImageURL,
            LandUnitsMapImage: LandUnitsMapImageURL,
            WaterwayMapImage: WaterwayMapImageURL,
            LandAndErosionMapImage: LandAndErosionMapImageURL,
            MahingKaiMapImage: MahingKaiMapImageURL,
            WaterTestSitesImage2: WaterTestSitesImage2URL,
            AllItemsMapImage: AllItemsMapImageURL,
            FreshwaterIrrigationMapImage: FreshwaterIrrigationMapImageURL,
            EffluentDisposalMapImage: EffluentDisposalMapImageURL,
            AllActionsMapImage: AllActionsMapImageURL,
            PhysicalWorksMapImage: PhysicalWorksMapImageURL,
            ActionDue: ActionDue,
            CroppingMapImage: CroppingMapImageURL,
            NutrientMapImage: NutrientMapImageURL,
            Type: 1,
            Notes: null,
            Username: null,
            FarmId: farmId,
            UserId: userId
        }
        var response = await apiPost(
            '/api/summary/SaveAutoUpload/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });

        if (response.data.status) {
            toast.success("Document details Uploaded!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            setAutoUploadSaving(false);
            window.location.reload(true);
        }
        else {
            setAutoUploadSaving(false);
            toast.error("Error while saving records!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }

    const exportSummaryToPdf = async () => {

        //toast.success("Sorry, can't generate this report yet. Coming soon...", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        //return false; 

        setGenerateReport(true);
        var ActionDue = null;
        toPng(elementRef.current, { cacheBust: true })
            .then((dataUrl) => {
                ActionDue = dataUrl;
                if (fepOnly) {
                    const response = ExportFEPSummaryReport(ActionDue);
                }
                else {
                    const response = ExportFWFPSummaryReport(ActionDue);
                }
            })
            .catch((err) => {
                if (fepOnly) {
                    const response = ExportFEPSummaryReport(ActionDue);
                }
                else {
                    const response = ExportFWFPSummaryReport(ActionDue);
                }
            });


    }
    const exportFEPSummaryToPdf = async () => {
        setGenerateFEPReport(true);
        var ActionDue = null;
        toPng(elementRef.current, { cacheBust: true })
            .then((dataUrl) => {
                ActionDue = dataUrl;
                const response = ExportFEPSummaryReport(ActionDue);
            })
            .catch((err) => {
                const response = ExportFEPSummaryReport(null);
            });


    }
    const ExportFWFPSummaryReport = async (ActionDue) => {
        let form = {
            FarmDetailImage: FarmDetailImageURL,
            InfrastructureMapImage: InfrastructureMapImageURL,
            LandUnitsMapImage: LandUnitsMapImageURL,
            WaterwayMapImage: WaterwayMapImageURL,
            LandAndErosionMapImage: LandAndErosionMapImageURL,
            MahingKaiMapImage: MahingKaiMapImageURL,
            WaterTestSitesImage2: WaterTestSitesImage2URL,
            AllItemsMapImage: WholeMapImageURL,
            FreshwaterIrrigationMapImage: FreshwaterIrrigationMapImageURL,
            EffluentDisposalMapImage: EffluentDisposalMapImageURL,
            AllActionsMapImage: AllActionsMapImageURL,
            PhysicalWorksMapImage: PhysicalWorksMapImageURL,
            ActionDue: ActionDue,
            CroppingMapImage: CroppingMapImageURL,
            NutrientMapImage: NutrientMapImageURL,
            FarmId: farmId,
            Type:'FWFP'
        }
       var response = await apiPost(
            '/api/summary/ExportFWFPSummaryReport/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });

        if (response.data.status) {
            setGenerateReport(false);
            toast.success("Report generated!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "FWFP Summary - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click();
        }
        else {
            setGenerateReport(false);
            toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }
    const ExportFEPSummaryReport = async (ActionDue) => {
        let form = {
            FarmDetailImage: FarmDetailImageURL,
            InfrastructureMapImage: InfrastructureMapImageURL,
            LandUnitsMapImage: LandUnitsMapImageURL,
            WaterwayMapImage: WaterwayMapImageURL,
            LandAndErosionMapImage: LandAndErosionMapImageURL,
            MahingKaiMapImage: MahingKaiMapImageURL,
            WaterTestSitesImage2: WaterTestSitesImage2URL,
            AllItemsMapImage: AllItemsMapImageURL,
            FreshwaterIrrigationMapImage: FreshwaterIrrigationMapImageURL,
            EffluentDisposalMapImage: EffluentDisposalMapImageURL,
            AllActionsMapImage: AllActionsMapImageURL,
            PhysicalWorksMapImage: PhysicalWorksMapImageURL,
            ActionDue: ActionDue,
            CroppingMapImage: CroppingMapImageURL,
            NutrientMapImage: NutrientMapImageURL,
            FarmId: farmId,
            Type: 'FEP'
        }
        var response = await apiPost(
            '/api/summary/ExportFWFPSummaryReport/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });

        if (response.data.status) {
            setGenerateReport(false);
            toast.success("Report generated!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "FWFP Summary - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click();
        }
        else {
            setGenerateReport(false);
            toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    const [generatePropertyMapReport, setGeneratePropertyMapReport] = useState(false);

    const exportPropertyMapToPdf = async () => {
        refreshToken();
        setGeneratePropertyMapReport(true);
        var PropertyMapImage = null;
        if (propertyMapUrl != '') {
            PropertyMapImage = await getBase64FromUrl(propertyMapUrl);
        }
        let form = {
            PropertyMapImage: PropertyMapImage,
            FarmId: farmId,
            Items: propertyMapItems.itemList
        }
        let response = await apiPost(
            '/api/summary/ExportPropertyMapReport/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data.status) {
            setGeneratePropertyMapReport(false);
            toast.success("Report generated!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "Property Map - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click();
        }
        else {
            setGeneratePropertyMapReport(false);
            toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }

    const exportActionsToPdf = async (e) => {

        //toast.success("Sorry, can't generate this report yet. Coming soon...", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        //return false; 

        e.stopPropagation();
        e.preventDefault();
        const response = handleActionsToPdf();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleActionsToPdf = async (e) => {
        refreshToken();
        let form = {
            AllActionsMapImage1: AllActionsMapImage1URL,
            farmId: farmId
        }
        let response = await apiPost(
            '/api/summary/GenerateActionsPdf/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "Actions - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click();
        }

    }

    const generateSummaryReport = async (ActionDue) => {
        var FarmDetailImage = null;
        var InfrastructureMapImage = null;
        var LandUnitsMapImage = null;
        var WaterwayMapImage = null;
        var LandAndErosionMapImage = null;
        var MahingKaiMapImage = null;
        var WaterTestSitesImage2 = null;
        var AllItemsMapImage = null;
        var EffluentDisposalMapImage = null;
        var FreshwaterIrrigationMapImage = null;
        var AllActionsMapImage = null;
        var PhysicalWorksMapImage = null;
        var CroppingMapImage = null;
        var NutrientMapImage = null;
        try {
            FarmDetailImage = await getBase64Image(document.getElementById('FarmDetailImage'));
        }
        catch
        {
            FarmDetailImage = null;
        }
        try {
            InfrastructureMapImage = await getBase64Image(document.getElementById('InfrastructureMapImage'));
        }
        catch
        {
            InfrastructureMapImage = null;
        }
        try {
            LandUnitsMapImage = await getBase64Image(document.getElementById('LandUnitsMapImage'));
        }
        catch
        {
            LandUnitsMapImage = null;
        }
        try {
            WaterwayMapImage = await getBase64Image(document.getElementById('WaterwayMapImage'));
        }
        catch
        {
            WaterwayMapImage = null;
        }
        try {
            LandAndErosionMapImage = await getBase64Image(document.getElementById('LandAndErosionMapImage'));
        }
        catch
        {
            LandAndErosionMapImage = null;
        }
        try {
            MahingKaiMapImage = await getBase64Image(document.getElementById('MahingKaiMapImage'));
        }
        catch
        {
            MahingKaiMapImage = null;
        }
        try {
            WaterTestSitesImage2 = await getBase64Image(document.getElementById('WaterTestSitesImage2'));
        }
        catch
        {
            WaterTestSitesImage2 = null;
        }
        try {
            AllItemsMapImage = await getBase64Image(document.getElementById('AllItemsMapImage'));
        }
        catch
        {
            AllItemsMapImage = null;
        }
        try {
            EffluentDisposalMapImage = await getBase64Image(document.getElementById('EffluentDisposalMapImage'));
        }
        catch
        {
            EffluentDisposalMapImage = null;
        }
        try {
            FreshwaterIrrigationMapImage = await getBase64Image(document.getElementById('FreshwaterIrrigationMapImage'));
        }
        catch
        {
            FreshwaterIrrigationMapImage = null;
        }
        try {
            AllActionsMapImage = await getBase64Image(document.getElementById('AllActionsMapImage'));
        }
        catch
        {
            AllActionsMapImage = null;
        }
        try {
            PhysicalWorksMapImage = await getBase64Image(document.getElementById('PhysicalWorksMapImage'));
        }
        catch
        {
            PhysicalWorksMapImage = null;
        }
        try {
            CroppingMapImage = await getBase64Image(document.getElementById('CroppingMapImage'));
        }
        catch
        {
            CroppingMapImage = null;
        }
        try {
            NutrientMapImage = await getBase64Image(document.getElementById('NutrientMapImage'));
        }
        catch
        {
            NutrientMapImage = null;
        }
        let form = {
            FarmDetailImage: FarmDetailImage,
            InfrastructureMapImage: InfrastructureMapImage,
            LandUnitsMapImage: null,
            WaterwayMapImage: null,
            LandAndErosionMapImage: null,
            MahingKaiMapImage: null,
            WaterTestSitesImage2: null,
            AllItemsMapImage: null,
            FreshwaterIrrigationMapImage: null,
            EffluentDisposalMapImage: null,
            AllActionsMapImage: null,
            PhysicalWorksMapImage: null,
            ActionDue: null,
            CroppingMapImage: null,
            NutrientMapImage: null,
            FarmId: farmId
        }

        let response = await apiPost(
            '/api/summary/ExportFWFPReport1/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });

        if (response.data.status) {
            form = {
                FarmDetailImage: null,
                InfrastructureMapImage: null,
                LandUnitsMapImage: LandUnitsMapImage,
                WaterwayMapImage: WaterwayMapImage,
                LandAndErosionMapImage: null,
                MahingKaiMapImage: null,
                WaterTestSitesImage2: null,
                AllItemsMapImage: null,
                FreshwaterIrrigationMapImage: null,
                EffluentDisposalMapImage: null,
                AllActionsMapImage: null,
                PhysicalWorksMapImage: null,
                ActionDue: null,
                CroppingMapImage: null,
                NutrientMapImage: null,
                FarmId: farmId
            }
            response = await apiPost(
                '/api/summary/ExportFWFPReport1_1/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });

            if (response.data.status) {
                form = {
                    FarmDetailImage: null,
                    InfrastructureMapImage: null,
                    LandUnitsMapImage: null,
                    WaterwayMapImage: null,
                    LandAndErosionMapImage: LandAndErosionMapImage,
                    MahingKaiMapImage: MahingKaiMapImage,
                    WaterTestSitesImage2: null,
                    AllItemsMapImage: null,
                    FreshwaterIrrigationMapImage: null,
                    EffluentDisposalMapImage: null,
                    AllActionsMapImage: null,
                    PhysicalWorksMapImage: null,
                    ActionDue: null,
                    CroppingMapImage: null,
                    NutrientMapImage: null,
                    FarmId: farmId
                }
                response = await apiPost(
                    '/api/summary/ExportFWFPReport2/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response.data.status) {
                    form = {
                        FarmDetailImage: null,
                        InfrastructureMapImage: null,
                        LandUnitsMapImage: null,
                        WaterwayMapImage: null,
                        LandAndErosionMapImage: null,
                        MahingKaiMapImage: null,
                        WaterTestSitesImage2: WaterTestSitesImage2,
                        AllItemsMapImage: AllItemsMapImage,
                        FreshwaterIrrigationMapImage: null,
                        EffluentDisposalMapImage: null,
                        AllActionsMapImage: null,
                        PhysicalWorksMapImage: null,
                        ActionDue: null,
                        CroppingMapImage: null,
                        NutrientMapImage: null,
                        FarmId: farmId
                    }
                    response = await apiPost(
                        '/api/summary/ExportFWFPReport2_1/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        });

                    if (response.data.status) {
                        form = {
                            FarmDetailImage: null,
                            InfrastructureMapImage: null,
                            LandUnitsMapImage: null,
                            WaterwayMapImage: null,
                            LandAndErosionMapImage: null,
                            MahingKaiMapImage: null,
                            WaterTestSitesImage2: null,
                            AllItemsMapImage: null,
                            FreshwaterIrrigationMapImage: FreshwaterIrrigationMapImage,
                            EffluentDisposalMapImage: EffluentDisposalMapImage,
                            AllActionsMapImage: null,
                            PhysicalWorksMapImage: null,
                            ActionDue: null,
                            CroppingMapImage: null,
                            NutrientMapImage: null,
                            FarmId: farmId
                        }
                        response = await apiPost(
                            '/api/summary/ExportFWFPReport3/', JSON.stringify(form),
                            {
                                headers: { 'Content-Type': 'application/json' },
                                withCredentials: true
                            });
                        if (response.data.status) {
                            form = {
                                FarmDetailImage: null,
                                InfrastructureMapImage: null,
                                LandUnitsMapImage: null,
                                WaterwayMapImage: null,
                                LandAndErosionMapImage: null,
                                MahingKaiMapImage: null,
                                WaterTestSitesImage2: null,
                                AllItemsMapImage: null,
                                FreshwaterIrrigationMapImage: null,
                                EffluentDisposalMapImage: null,
                                AllActionsMapImage: AllActionsMapImage,
                                PhysicalWorksMapImage: PhysicalWorksMapImage,
                                ActionDue: null,
                                CroppingMapImage: null,
                                NutrientMapImage: null,
                                FarmId: farmId
                            }
                            response = await apiPost(
                                '/api/summary/ExportFWFPReport3_1/', JSON.stringify(form),
                                {
                                    headers: { 'Content-Type': 'application/json' },
                                    withCredentials: true
                                });
                            if (response.data.status) {
                                form = {
                                    FarmDetailImage: null,
                                    InfrastructureMapImage: null,
                                    LandUnitsMapImage: null,
                                    WaterwayMapImage: null,
                                    LandAndErosionMapImage: null,
                                    MahingKaiMapImage: null,
                                    WaterTestSitesImage2: null,
                                    AllItemsMapImage: null,
                                    FreshwaterIrrigationMapImage: null,
                                    EffluentDisposalMapImage: null,
                                    AllActionsMapImage: null,
                                    PhysicalWorksMapImage: null,
                                    ActionDue: ActionDue,
                                    CroppingMapImage: CroppingMapImage,
                                    NutrientMapImage: null,
                                    FarmId: farmId
                                }
                                response = await apiPost(
                                    '/api/summary/ExportFWFPReport4/', JSON.stringify(form),
                                    {
                                        headers: { 'Content-Type': 'application/json' },
                                        withCredentials: true
                                    });
                                if (response.data.status) {
                                    form = {
                                        FarmDetailImage: null,
                                        InfrastructureMapImage: null,
                                        LandUnitsMapImage: null,
                                        WaterwayMapImage: null,
                                        LandAndErosionMapImage: null,
                                        MahingKaiMapImage: null,
                                        WaterTestSitesImage2: null,
                                        AllItemsMapImage: null,
                                        FreshwaterIrrigationMapImage: null,
                                        EffluentDisposalMapImage: null,
                                        AllActionsMapImage: null,
                                        PhysicalWorksMapImage: null,
                                        ActionDue: null,
                                        CroppingMapImage: null,
                                        NutrientMapImage: NutrientMapImage,
                                        FarmId: farmId
                                    }
                                    response = await apiPost(
                                        '/api/summary/ExportFWFPReport4_1/', JSON.stringify(form),
                                        {
                                            headers: { 'Content-Type': 'application/json' },
                                            withCredentials: true
                                        });

                                    if (response.data.status) {
                                        setGenerateReport(false);
                                        toast.success("Report generated!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                                        var buffer = base64ToArrayBuffer(response.data.content)
                                        var file = new Blob([buffer], { type: "application/pdf" })
                                        var link = document.createElement('a')
                                        link.href = window.URL.createObjectURL(file)
                                        link.download = "FWFP Summary - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
                                        document.body.appendChild(link)
                                        link.click();
                                    }
                                    else {
                                        setGenerateReport(false);
                                        toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                                    }
                                }
                                else {
                                    setGenerateReport(false);
                                    toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                                }
                            }
                            else {
                                setGenerateReport(false);
                                toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                            }
                        }
                        else {
                            setGenerateReport(false);
                            toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                        }
                    }
                    else {
                        setGenerateReport(false);
                        toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    }
                }
                else {
                    setGenerateReport(false);
                    toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                }
            }
            else {
                setGenerateReport(false);
                toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
        else {
            setGenerateReport(false);
            toast.error("Error when generating report", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        return response;
    }

    const handleReportSaveHistory = async (e, form) => {
        try {
            const response = await apiPost(
                '/api/summary/SaveReportHistory/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                return response
            }
        } catch (error) {
            throw error;
        }
    }

    const getActionDueImage = async () => {
        var ActionDue = null;
        toPng(elementRef.current, { cacheBust: true })
            .then((dataUrl) => {
                ActionDue = dataUrl;
                setActionDueImage(ActionDue);
            }).catch((err) => {
                setActionDueImage(null)
            });
    }

    const handleReportSaveToHistory = async (e, form) => {
        var SaveReportHistory = {
            ReportImages: {},
            ReportData: form
        };

        var ActionDue = null;
        let form1 = {
            FarmDetailImage: FarmDetailImageURL,
            InfrastructureMapImage: InfrastructureMapImageURL,
            LandUnitsMapImage: LandUnitsMapImageURL,
            WaterwayMapImage: WaterwayMapImageURL,
            LandAndErosionMapImage: LandAndErosionMapImageURL,
            MahingKaiMapImage: MahingKaiMapImageURL,
            WaterTestSitesImage2: WaterTestSitesImage2URL,
            AllItemsMapImage: AllItemsMapImageURL,
            FreshwaterIrrigationMapImage: FreshwaterIrrigationMapImageURL,
            EffluentDisposalMapImage: EffluentDisposalMapImageURL,
            AllActionsMapImage: AllActionsMapImageURL,
            PhysicalWorksMapImage: PhysicalWorksMapImageURL,
            ActionDue: ActionDue,
            CroppingMapImage: CroppingMapImageURL,
            NutrientMapImage: NutrientMapImageURL,
            FarmId: farmId,
            Type: 'FWFP'
        }

        ActionDue = actionDueImage;
        form1.ActionDue = ActionDue;
        SaveReportHistory.ReportImages = form1;

        try {
            var response =await handleReportSaveHistory(e, SaveReportHistory);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    const labels = summary.actionDues.labelsList;
    const data = summary.actionDues.costList;

    const dataBar = {
        labels: labels,
        datasets: [
            {
                label: "#Actions",
                backgroundColor: "#189de4",
                borderColor: "#189de4",
                borderWidth: 1,
                hoverBackgroundColor: "#52b7e9",
                hoverBorderColor: "#52b7e9",
                data: data,
            }
        ]
    };

    const options = {
        plugins: {
            datalabels: {
                display: true,
                color: "#41533d",
                formatter: function (value) {
                    return value == 0 ? '' : value
                },
                anchor: "end",
                offset: -20,
                align: "start"
            },
            legend: {
                display: true
            },

        },
        scales: {
            // to remove the labels
            x: {
                ticks: {
                    display: true,
                    color: "#41533d",
                    font: {
                        size: 14,
                        weight: "bold"
                    }
                },

                // to remove the x-axis grid
                grid: {
                    drawBorder: false,
                    display: false,
                },
            },
            // to remove the y-axis labels
            y: {
                ticks: {
                    display: false,
                },
                // to remove the y-axis grid
                grid: {
                    drawBorder: false,
                    display: true,
                },
            },
        },
    }

    const staticOutlinemapView = useMemo(() => {
        return (
            <StaticMapView itemModel={outline} mapDetails={mapDetails} farmCentreReq={true} id="FarmDetailImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticInfrastructuremapView = useMemo(() => {
        return (
            <StaticMapView itemModel={infrastructure} mapDetails={mapDetails} farmCentreReq={false} id="InfrastructureMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticLUmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={lmu} mapDetails={mapDetails} farmCentreReq={false} id="LandUnitsMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticWaterwaysmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={waterway} mapDetails={mapDetails} farmCentreReq={false} id="WaterwayMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticLandSoilmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={landsoil} mapDetails={mapDetails} farmCentreReq={false} id="LandAndErosionMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticMahingaKaimapView = useMemo(() => {
        return (
            <StaticMapView itemModel={mahingaKai} mapDetails={mapDetails} farmCentreReq={false} id="MahingKaiMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticFarmAPTmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={catchmentContext} mapDetails={catchmentContextMapDetails} farmCentreReq={false} id="WaterTestSitesImage2" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticAllItemsmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={allItems} mapDetails={mapDetails} farmCentreReq={false} id="AllItemsMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticItemActionPlanListmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={itemActionPlanList} mapDetails={mapDetails} farmCentreReq={false} id="AllActionsMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticItemActionPlanList1mapView = useMemo(() => {
        return (
            <StaticMapView itemModel={itemActionPlanList1} mapDetails={mapDetails} farmCentreReq={false} id="AllActionsMapImage1" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticItemPhysicalWorksPlanListmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={itemPhysicalWorksPlanList} mapDetails={mapDetails} farmCentreReq={false} id="PhysicalWorksMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticEffluentDisposalmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={effluentDisposal} mapDetails={mapDetails} farmCentreReq={false} id="EffluentDisposalMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticFreshwaterIrrigationmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={freshWaterIrrigation} mapDetails={mapDetails} farmCentreReq={false} id="FreshwaterIrrigationMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticCroppingmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={cropping} mapDetails={mapDetails} farmCentreReq={false} id="CroppingMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const staticNutrientmapView = useMemo(() => {
        return (
            <StaticMapView itemModel={nutrients} mapDetails={mapDetails} farmCentreReq={false} id="NutrientMapImage" setReportButtonVisible={setReportButtonVisible} />
        )
    })
    const getBase64Image = async (img) => {
        try {
            var dataURL = null;
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            dataURL = canvas.toDataURL("image/png");
            return dataURL;
        }
        catch {
            return dataURL;
        }
    }
    const elementRef = useRef(null);

    const exportAdminDetailPdf = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleAdminDetailToPdf();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }
    const handleAdminDetailToPdf = async (e) => {
        refreshToken();
        const response = await apiGet(
            '/api/summary/GenerateAdminDetailPdf/', {
            params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "Admin Detail - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click();
        }

    }
    const exportActionPlanToExcel = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportActionPlanToExcel();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportActionPlanToExcel = async (e) => {
        const response = await apiGet(
            '/api/summary/GenerateReportINFDPActionPlanExcel/', {
            params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "OpenActions - " + farmName.toString() + " - " + farmUniqueId.toString() + ".xlsx";
            document.body.appendChild(link)
            link.click()
        }

    }
    const exportActionPlanToExcel_Canterbury = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportActionPlanToExcel_Canterbury();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportActionPlanToExcel_Canterbury = async (e) => {
        const response = await apiGet(
            '/api/summary/GenerateReportINFDPActionPlanExcel_Canterbury/', {
            params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "OpenActions - " + farmName.toString() + " - " + farmUniqueId.toString() + ".xlsx";
            document.body.appendChild(link)
            link.click()
        }

    }
    const exportSchedule7_Canterbury = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportSchedule7_Canterbury();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportSchedule7_Canterbury = async (e) => {
        const response = await apiGet(
            '/api/summary/GenerateReportSchedule7_Canterbury/', {
            params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "Schedule7 - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click()
        }

    }
    const exportGMP_Canterbury = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportGMP_Canterbury();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportGMP_Canterbury = async (e) => {
        const response = await apiGet(
            '/api/summary/GenerateReportGMP_Canterbury/', {
            params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "GMP - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click()
        }

    }

    const exportActionsToExcel = async (e) => {
        //toast.success("Sorry, can't generate this report yet. Coming soon...", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        //return false; 
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportActionsToExcel();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportActionsToExcel = async (e) => {
        refreshToken();
        const response = await apiGet(
            '/api/allFarmsSummary/GenerateReportOpenActionsExcelV1/', {
                params: { UserId: userId, farmId: farmId, farmlist:null }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "Actions - " + farmName.toString() + " - " + farmUniqueId.toString() + ".xlsx";
            document.body.appendChild(link)
            link.click()
        }

    }

    const generateRegulatoryExport = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleRegulatoryExport();
        toast.promise(response, {
            loading: 'Exporting...',
            success: 'Export completed!',
            error: 'Error when generating report',
        });
    }

    const handleRegulatoryExport = async (e) => {
        const response = await apiGet(
            '/api/summary/GenerateRegulatoryExport/', {
            params: { farmId: farmId }
        })

        if (response.data.status) {
            let filename = "Regulatory Export - " + farmName.toString() + " - " + farmUniqueId.toString() + ".geojson";
            let contentType = "application/json;charset=utf-8;";
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                var blob = new Blob([decodeURIComponent(encodeURI(JSON.stringify(response.data.content)))], { type: contentType });
                navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var a = document.createElement('a');
                a.download = filename;
                a.href = 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(response.data.content));
                a.target = '_blank';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        }

    }

    const exportRiskAndActionsToPdf = async (e) => {
        //toast.success("Sorry, can't generate this report yet. Coming soon...", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        //return false; 
        e.stopPropagation();
        e.preventDefault();
        const response = handleRiskAndActionsToPdf();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleRiskAndActionsToPdf = async (e) => {
        const response = await apiGet(
            '/api/summary/GenerateRiskAndActionsPdf/', {
            params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "FWFP Risks and Actions - " + farmName.toString() + " - " + farmUniqueId.toString() + ".pdf";
            document.body.appendChild(link)
            link.click();
        }

    }
    const getFarmCentre = async (outlineList1, zoomlevel1) => {
        const outlineList = outlineList1;
        const zoomlevel = zoomlevel1;
        var center = null;
        /* Farm center*/
        if (outlineList.length > 0) {
            let OutlineTypeLength = outlineList.filter(type => type.mapType == 'marker').length;
            if (OutlineTypeLength > 0) {
                outlineList.filter(type => type.mapType == 'marker').map((item) => {
                    center = { lat: parseFloat(item.coordinates.split(',')[0]), lng: parseFloat(item.coordinates.split(',')[1]) }
                })
            }
            else {
                OutlineTypeLength = outlineList.filter(type => type.mapType == 'polygon').length;
                if (OutlineTypeLength > 0) {
                    let Polylist = outlineList.filter(type => type.mapType == 'polygon');
                    const Coord = Polylist[0].coordinates.split(':')[0]
                    center = { lat: parseFloat(Coord.split(',')[0]), lng: parseFloat(Coord.split(',')[1]) }
                }
            }

        }
        return center;
    }
    const renderPropertyMapItem = async (itemList, isLU) => {
        var itemPolygonString = '';
        var itemPolygonMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "polygon").map(item => {
            const Coordinates = item.mapCoordinates.split(':');
            let positions = "";
            let pos1 = "";
            const positionsArry = [];

            Coordinates.filter(coor => coor != "").map((Coordinate) => {
                let pos = parseFloat(Coordinate.split(',')[0]) + "," + parseFloat(Coordinate.split(',')[1]);
                positionsArry.push(pos);
                if (positions != "") {
                    positions = positions + "|" + pos;
                }
                else {
                    positions = pos;
                    pos1 = pos;
                }
            })
            positions = positions + "|" + pos1;

            const vertices = splitpolygonCoor(positions);
            const encodedPolygon = encodeShapeCoordinates(vertices);

            let borderColor = item.colour.replace('#', '');
            let fillColor = borderColor.length == 8 ? borderColor.slice(0, -2) + '40' : borderColor.length == 6 ? borderColor + '40' : borderColor;
            itemPolygonString = itemPolygonString != '' ? itemPolygonString + `&shape=fill:${fillColor}|border:${borderColor}|cmp|enc:${encodedPolygon}` : `fill:${fillColor}|border:${borderColor}|cmp|enc:${encodedPolygon}`;
            if (isLU) {
                if (!item.isConnectedToAnotherLMU) {
                    const centrePoint = findPolygonCenterPoint(positions);
                    let itemPolygonMarker = parseFloat(centrePoint[0]) + "," + parseFloat(centrePoint[1]) + "|marker-" + item.mapLabel;
                    itemPolygonMarkerString = itemPolygonMarkerString != '' ? itemPolygonMarkerString + "||" + itemPolygonMarker : itemPolygonMarker;
                }
            }
            else {
                const centrePoint = findPolygonCenterPoint(positions);
                let itemPolygonMarker = parseFloat(centrePoint[0]) + "," + parseFloat(centrePoint[1]) + "|marker-" + item.mapLabel;
                itemPolygonMarkerString = itemPolygonMarkerString != '' ? itemPolygonMarkerString + "||" + itemPolygonMarker : itemPolygonMarker;
            }

        })
        var itemPolylineString = '';
        var itemPolylineMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "polyline").map(item => {
            const Coordinates = item.mapCoordinates.split(':');
            let positions = "";
            let pos1 = "";
            Coordinates.filter(coor => coor != "").map((Coordinate) => {
                let pos = parseFloat(Coordinate.split(',')[0]) + "," + parseFloat(Coordinate.split(',')[1]);
                if (positions != "") {
                    positions = positions + "|" + pos;
                }
                else {
                    positions = pos;
                    pos1 = pos;
                }
            })

            const vertices = splitpolygonCoor(positions);
            const encodedPolyline = encodeShapeCoordinates(vertices);

            let borderColor = item.colour.replace('#', '');
            itemPolylineString = itemPolylineString != '' ? itemPolylineString + `&shape=border:${borderColor}|cmp|enc:${encodedPolyline}` : `border:${borderColor}|cmp|enc:${encodedPolyline}`;

            let itemPolylineMarker = pos1 + "|marker-" + item.mapLabel;
            itemPolylineMarkerString = itemPolylineMarkerString != '' ? itemPolylineMarkerString + "||" + itemPolylineMarker : itemPolylineMarker;

        })
        var itemRectangleString = '';
        var itemRectangleMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "rectangle").map(item => {

            let positions = "";

            const northEastCO = item.mapCoordinates.split(':')[0];
            const southWestCo = item.mapCoordinates.split(':')[1];

            const co1 = parseFloat(northEastCO.split(',')[0]) + "," + parseFloat(northEastCO.split(',')[1]);
            const co2 = parseFloat(southWestCo.split(',')[0]) + "," + parseFloat(northEastCO.split(',')[1]);
            const co3 = parseFloat(northEastCO.split(',')[0]) + "," + parseFloat(southWestCo.split(',')[1]);
            const co4 = parseFloat(southWestCo.split(',')[0]) + "," + parseFloat(southWestCo.split(',')[1]);

            positions = co1 + "|" + co2 + "|" + co4 + "|" + co3 + "|" + co1;

            const vertices = splitpolygonCoor(positions);
            const encodedRectangle = encodeShapeCoordinates(vertices);

            let borderColor = item.colour.replace('#', '');
            itemRectangleString = itemRectangleString != '' ? itemRectangleString + `&shape=border:${borderColor}|cmp|enc:${encodedRectangle}` : `border:${borderColor}|cmp|enc:${encodedRectangle}`;

            const centrePoint = findPolygonCenterPoint(positions);

            let itemRectangleMarker = parseFloat(centrePoint[0]) + "," + parseFloat(centrePoint[1]) + "|marker-" + item.mapLabel;
            itemRectangleMarkerString = itemRectangleMarkerString != '' ? itemRectangleMarkerString + "||" + itemRectangleMarker : itemRectangleMarker;

        })
        var itemCircleString = '';
        var itemCircleMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "circle").map(item => {

            const positions = parseFloat(item.mapCoordinates.split(',')[0]) + "," + parseFloat(item.mapCoordinates.split(',')[1]);
            const radius = parseFloat((item.radius / 1000));

            let borderColor = item.colour.replace('#', '');
            itemCircleString = itemCircleString != '' ? itemCircleString + `radius:${radius}km|border:${borderColor}|${positions}` : `radius:${radius}km|border:${borderColor}|${positions}`;

            const centrePoint = findPolygonCenterPoint(positions);

            let itemRectangleMarker = parseFloat(centrePoint[0]) + "," + parseFloat(centrePoint[1]) + "|marker-" + item.mapLabel;
            itemCircleMarkerString = itemCircleMarkerString != '' ? itemCircleMarkerString + "||" + itemRectangleMarker : itemRectangleMarker;

        })
        return {
            itemPolygonString: itemPolygonString, itemPolygonMarkerString: itemPolygonMarkerString,
            itemPolylineString: itemPolylineString, itemPolylineMarkerString: itemPolylineMarkerString,
            itemRectangleString: itemRectangleString, itemRectangleMarkerString: itemRectangleMarkerString,
            itemCircleString: itemCircleString, itemCircleMarkerString: itemCircleMarkerString
        }
    }
    const renderPropertyMapItemDefaultMarker = async (itemList, isLU) => {
        var itemPolygonString = '';
        var itemPolygonMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "polygon").map(item => {
            const Coordinates = item.mapCoordinates.split(':');
            let positions = "";
            let pos1 = "";
            const positionsArry = [];

            Coordinates.filter(coor => coor != "").map((Coordinate) => {
                let pos = parseFloat(Coordinate.split(',')[0]) + "," + parseFloat(Coordinate.split(',')[1]);
                positionsArry.push(pos);
                if (positions != "") {
                    positions = positions + "|" + pos;
                }
                else {
                    positions = pos;
                    pos1 = pos;
                }
            })
            positions = positions + "|" + pos1;

            const vertices = splitpolygonCoor(positions);
            const encodedPolygon = encodeShapeCoordinates(vertices);

            let borderColor = item.colour.replace('#', '');
            let fillColor = borderColor.length == 8 ? borderColor.slice(0, -2) + '40' : borderColor.length == 6 ? borderColor + '40' : borderColor;
            itemPolygonString = itemPolygonString != '' ? itemPolygonString + `&shape=fill:${fillColor}|border:${borderColor}|cmp|enc:${encodedPolygon}` : `fill:${fillColor}|border:${borderColor}|cmp|enc:${encodedPolygon}`;
            if (isLU) {
                if (!item.isConnectedToAnotherLMU) {
                    const centrePoint = findPolygonCenterPoint(positions);
                    let itemPolygonMarker = parseFloat(centrePoint[0]) + "," + parseFloat(centrePoint[1]);
                    itemPolygonMarkerString = itemPolygonMarkerString != '' ? itemPolygonMarkerString + "||" + itemPolygonMarker : itemPolygonMarker;
                }
            }
            else {
                const centrePoint = findPolygonCenterPoint(positions);
                let itemPolygonMarker = parseFloat(centrePoint[0]) + "," + parseFloat(centrePoint[1]);
                itemPolygonMarkerString = itemPolygonMarkerString != '' ? itemPolygonMarkerString + "||" + itemPolygonMarker : itemPolygonMarker;
            }

        })
        var itemPolylineString = '';
        var itemPolylineMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "polyline").map(item => {
            const Coordinates = item.mapCoordinates.split(':');
            let positions = "";
            let pos1 = "";
            Coordinates.filter(coor => coor != "").map((Coordinate) => {
                let pos = parseFloat(Coordinate.split(',')[0]) + "," + parseFloat(Coordinate.split(',')[1]);
                if (positions != "") {
                    positions = positions + "|" + pos;
                }
                else {
                    positions = pos;
                    pos1 = pos;
                }
            })

            const vertices = splitpolygonCoor(positions);
            const encodedPolyline = encodeShapeCoordinates(vertices);

            let borderColor = item.colour.replace('#', '');
            itemPolylineString = itemPolylineString != '' ? itemPolylineString + `&shape=border:${borderColor}|cmp|enc:${encodedPolyline}` : `border:${borderColor}|cmp|enc:${encodedPolyline}`;

            let itemPolylineMarker = pos1;
            itemPolylineMarkerString = itemPolylineMarkerString != '' ? itemPolylineMarkerString + "||" + itemPolylineMarker : itemPolylineMarker;
        });
        var itemRectangleString = '';
        var itemRectangleMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "rectangle").map(item => {

            let positions = "";

            const northEastCO = item.mapCoordinates.split(':')[0];
            const southWestCo = item.mapCoordinates.split(':')[1];

            const co1 = parseFloat(northEastCO.split(',')[0]) + "," + parseFloat(northEastCO.split(',')[1]);
            const co2 = parseFloat(southWestCo.split(',')[0]) + "," + parseFloat(northEastCO.split(',')[1]);
            const co3 = parseFloat(northEastCO.split(',')[0]) + "," + parseFloat(southWestCo.split(',')[1]);
            const co4 = parseFloat(southWestCo.split(',')[0]) + "," + parseFloat(southWestCo.split(',')[1]);

            positions = co1 + "|" + co2 + "|" + co4 + "|" + co3 + "|" + co1;

            const vertices = splitpolygonCoor(positions);
            const encodedRectangle = encodeShapeCoordinates(vertices);

            let borderColor = item.colour.replace('#', '');
            itemRectangleString = itemRectangleString != '' ? itemRectangleString + `&shape=border:${borderColor}|cmp|enc:${encodedRectangle}` : `border:${borderColor}|cmp|enc:${encodedRectangle}`;

            const centrePoint = findPolygonCenterPoint(positions);

            let itemRectangleMarker = parseFloat(centrePoint[0]) + "," + parseFloat(centrePoint[1]);
            itemRectangleMarkerString = itemRectangleMarkerString != '' ? itemRectangleMarkerString + "||" + itemRectangleMarker : itemRectangleMarker;

        })
        var itemCircleString = '';
        var itemCircleMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "circle").map(item => {

            const positions = parseFloat(item.mapCoordinates.split(',')[0]) + "," + parseFloat(item.mapCoordinates.split(',')[1]);
            const radius = parseFloat((item.radius / 1000));

            let borderColor = item.colour.replace('#', '');
            itemCircleString = itemCircleString != '' ? itemCircleString + `radius:${radius}km|border:${borderColor}|${positions}` : `radius:${radius}km|border:${borderColor}|${positions}`;

            const centrePoint = findPolygonCenterPoint(positions);

            let itemRectangleMarker = parseFloat(centrePoint[0]) + "," + parseFloat(centrePoint[1]);
            itemCircleMarkerString = itemCircleMarkerString != '' ? itemCircleMarkerString + "||" + itemRectangleMarker : itemRectangleMarker;

        });
        return {
            itemPolygonString: itemPolygonString, itemPolygonMarkerString: itemPolygonMarkerString,
            itemPolylineString: itemPolylineString, itemPolylineMarkerString: itemPolylineMarkerString,
            itemRectangleString: itemRectangleString, itemRectangleMarkerString: itemRectangleMarkerString,
            itemCircleString: itemCircleString, itemCircleMarkerString: itemCircleMarkerString
        }
    }
    function encodeShapeCoordinates(coordinates) {
        return polyline.encode(coordinates);
    }
    function findPolygonCenterPoint(CoordinatesList){
    if (CoordinatesList.length === 0) {
        return null;
    }
    const vertices = splitpolygonCoor(CoordinatesList);
    const sumX = vertices.reduce((acc, vertex) => acc + vertex[0], 0);
    const sumY = vertices.reduce((acc, vertex) => acc + vertex[1], 0);

    const centerX = parseFloat((sumX / vertices.length).toFixed(6));
    const centerY = parseFloat((sumY / vertices.length).toFixed(6));

    return [centerX, centerY];
};
    function splitpolygonCoor(Coordinates){
        if (Coordinates.length === 0) {
            return null;
        }

        let CoordinatesList = [];
        const CoorList = Coordinates.split('|');

        CoorList.filter(coor => coor != "").map((point) => {
            let pos = point.split(',').map(i => Number(i));
            CoordinatesList.push(pos);
        })
        return CoordinatesList;
    };
    function renderItemDefaultMarker(itemList) {
        var itemMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "marker").map((item) => {
            const itemColor = item.colour.replace('#', '');
            let itemMarker = parseFloat(item.mapCoordinates.split(',')[0]) + "," + parseFloat(item.mapCoordinates.split(',')[1]);
            itemMarkerString = itemMarkerString != '' ? itemMarkerString + "||" + itemMarker : itemMarker;
        }
        )
        return itemMarkerString;
    }
    function renderItemMarker(itemList) {
        var itemMarkerString = '';
        itemList.filter(type => type.mapMarkerType == "marker").map((item) => {
            const itemColor = item.colour.replace('#', '');
            let itemMarker = parseFloat(item.mapCoordinates.split(',')[0]) + "," + parseFloat(item.mapCoordinates.split(',')[1]) + "|marker-" + itemColor + "-" + item.mapLabel;
            itemMarkerString = itemMarkerString != '' ? itemMarkerString + "||" + itemMarker : itemMarker;
        }
        )
        return itemMarkerString;
    }
    function renderOutline(outlineList) {
        var farmOutline = '';
        outlineList.filter(type => type.mapType == "polygon").map(FarmOutline => {
            const Coordinates = FarmOutline.coordinates.split(':');
            let positions = "";
            let pos1 = "";

            Coordinates.filter(coor => coor != "").map((Coordinate) => {
                let pos = parseFloat(Coordinate.split(',')[0]) + "," + parseFloat(Coordinate.split(',')[1]);
                if (positions != "") {
                    positions = positions + "|" + pos;
                }
                else {
                    positions = pos;
                    pos1 = pos;
                }
            })
            positions = positions + "|" + pos1;

            const vertices = splitpolygonCoor(positions);
            const encodedPolygon = encodeShapeCoordinates(vertices);

            let borderColor = ''//ff0000
            if (!FarmOutline.isOutlineLeased) {
                borderColor = 'ff0000'
            }
            else {
                borderColor = 'FFFF00'
            }
            farmOutline = farmOutline != '' ? farmOutline + `&shape=border:${borderColor}|cmp|enc:${encodedPolygon}` : `border:${borderColor}|cmp|enc:${encodedPolygon}`;

        });
        return farmOutline;
    }
    function renderFarmCenter(outlineList) {
        var farmCenter = '';
        outlineList.filter(type => type.mapType == "marker").map((FarmCenter) => {
            let farmCenter1 = parseFloat(FarmCenter.coordinates.split(',')[0]) + "," + parseFloat(FarmCenter.coordinates.split(',')[1]) + "|marker-D51A1A"//-" + FarmCenter.mapLabel;
            farmCenter = farmCenter1;
        }
        );
        return farmCenter;
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row className="heading-underline">
                <Col><h3 className="header3">{summary.SectionName}</h3></Col>
                <Col>
                    <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(summary.SectionName)}>Back <FaChevronLeft /> </Button>
                </Col>
            </Row>
            {!staticMapLoading &&
                <Row style={{ display: "none" }}>
                    <Col>
                        <div style={{ display: "none" }}>
                            {/*{staticOutlinemapView}<br />*/}
                            {/*{staticInfrastructuremapView}<br />*/}
                            {/*{staticLUmapView}<br />*/}
                            {/*{staticWaterwaysmapView}<br />*/}
                            {/*{staticLandSoilmapView}<br />*/}
                            {/*{staticMahingaKaimapView}<br />*/}
                            {/*{staticFarmAPTmapView}<br />*/}
                            {/*{staticAllItemsmapView}<br />*/}
                            {/*{staticEffluentDisposalmapView}<br />*/}
                            {/*{staticFreshwaterIrrigationmapView}<br />*/}
                            {/*{staticItemActionPlanListmapView}<br />*/}
                            {/*{staticItemActionPlanList1mapView}<br />*/}
                            {/*{staticItemPhysicalWorksPlanListmapView}<br />*/}
                            {/*{staticCroppingmapView}<br />*/}
                            {/*{staticNutrientmapView}*/}
                        </div>
                    </Col>
                </Row>
            }
            {loading ? <SpinnerContainer /> :
                <>
                    <Row>
                        <Col sm="8">
                            <Row>
                                <Col sm="12">
                                    <ActionSummary refreshToken={refreshToken} ghgItemTypesList={summary.ghgItemTypesList} riskModel={riskModel} largeEnterpriseDetails={largeEnterpriseDetails}
                                        landsoil={landsoil.itemList} waterway={waterway.itemList} infrastructure={infrastructure.itemList}
                                        freshWaterIrrigation={freshWaterIrrigation.itemList} effluentDisposal={effluentDisposal.itemList}
                                        cropping={cropping.itemList} nutrients={nutrients.itemList}
                                    ></ActionSummary>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm="4">
                            <Row>
                                <Col sm="12">
                                    <Reporting getActionDueImage={getActionDueImage} handleReportSaveToHistory={handleReportSaveToHistory} showEnvironmentCanterbury={showEnvironmentCanterbury} handleSetFEPOnly={handleSetFEPOnly} fepOnly={fepOnly} exportAutoUploadToPdf={exportAutoUploadToPdf} autoUploadSaving={autoUploadSaving} generateFEPReport={generateFEPReport} exportFEPSummaryToPdf={exportFEPSummaryToPdf} generateReport={generateReport} reportButtonVisible={reportButtonVisible} exportSummaryToPdf={exportSummaryToPdf} farmId={farmId} reportDocumentList={summary.reportDocumentList}></Reporting>
                                </Col>

                            </Row>
                            <Row>
                                <Col sm="12">
                                    <Card className="my-4">
                                        <CardHeader className="card-header-dark-click" onClick={toggle}>
                                            <Row>
                                                <Col sm="11"><h5>My reports
                                                </h5>
                                                </Col>
                                                <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                            </Row>
                                        </CardHeader>
                                        <Collapse isOpen={isOpen}>
                                            <CardBody>
                                                <Row>
                                                    <Col sm="12"><label style={{ color: "black", fontSize: "14px" }}>
                                                        The following reports can be downloaded
                                                    </label>
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginTop: "5px" }}>
                                                    <Col sm="6" style={{ display: "none" }}>
                                                        <Row>
                                                            <Col sm="6"><b><label style={{ color: "black", fontSize: "14px" }}>INFDP Admin Info</label></b></Col>
                                                            <Col sm="6"><Button style={{ fontSize: "13px" }} color="success" onClick={(e) => exportAdminDetailPdf(e)} size="sm">Admin Detail <img src="/images/PDF_icon.png" className="card_icon" ></img></Button></Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Row>
                                                            <Col sm="5"><b><label style={{ color: "black", fontSize: "14px" }}>Action Report</label></b></Col>
                                                            <Col sm="7">{reportButtonVisible && <Button style={{ fontSize: "13px" }} color="success" onClick={(e) => exportActionsToPdf(e)} size="sm">Action Plan <img src="/images/PDF_icon.png" className="card_icon" ></img></Button>}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Row>
                                                            <Col sm="5"><b><label style={{ color: "black", fontSize: "14px" }}>Action Report</label></b></Col>
                                                            <Col sm="7"><Button style={{ fontSize: "13px" }} color="success" onClick={(e) => exportActionsToExcel(e)} size="sm">Action Plan <img src="/images/Excel_icon.png" className="card_icon" ></img></Button></Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="12">
                                                        <hr />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="6">
                                                        <Row>
                                                            <Col sm="5"><b><label style={{ color: "black", fontSize: "14px" }}>Risk & Actions</label></b></Col>
                                                            <Col sm="7"><Button style={{ fontSize: "13px" }} color="success" onClick={(e) => exportRiskAndActionsToPdf(e)} size="sm">Risks and Actions <img src="/images/PDF_icon.png" className="card_icon" ></img></Button></Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="6" style={{ display: "none" }}>
                                                        <Row>
                                                            <Col sm="6"><b><label style={{ color: "black", fontSize: "14px" }}>Regulatory Export</label></b></Col>
                                                            <Col sm="6"><Button style={{ fontSize: "13px" }} color="success" onClick={(e) => generateRegulatoryExport(e)} size="sm">Export to GeoJSON</Button></Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/*<Row className="heading-underline">*/}
                        {/*<Col><h4>Action Management</h4></Col>*/}
                    {/*</Row>*/}
                    <Row>
                        <Col sm="8" style={{ maxHeight: "100vh", overflowY: "auto" }}>
                            <RiskManagement></RiskManagement>
                        </Col>
                        <Col sm="4">
                            <ActionDue elementRef={elementRef} ActionDueList={summary.actionDues} OngoingActionDueList={summary.ongoingActionDues}></ActionDue>
                        </Col>
                    </Row>
                    {/*<Row className="heading-underline">*/}
                        {/*<Col><h4>Risk Management</h4></Col>*/}
                    {/*</Row>*/}
                    {/*<Row>*/}
                        {/*<Col sm="8" style={{ maxHeight: "100vh", overflowY: "auto" }}>*/}
                            
                        {/*</Col>*/}
                        {/*<Col sm="4">*/}
                        {/*    <CertificationStatus certificationAndAuditStatus={summary.certificationAndAuditStatus}*/}
                        {/*        summary={summary}*/}
                        {/*        isWizardCompleted={summary.isWizardCompleted}*/}
                        {/*        wizardDetails={summary.wizardDetails}*/}
                        {/*        handleWizardChanged={handleWizardChanged}*/}
                        {/*    ></CertificationStatus>*/}
                        {/*</Col>*/}
                    {/*</Row>*/}                   
                </>
            }
        </div>
    )
}
export default Summary;